import React, { useEffect } from 'react';
import { Phone, Mail, MapPin, MessageCircle, Clock } from 'lucide-react';

const Contact = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);



    return (
        <div className="bg-gray-50 min-h-screen relative">
            {/* WhatsApp Floating Button */}
            <a
                href="https://wa.me/919098027286"
                target="_blank"
                rel="noopener noreferrer"
                className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-transform hover:scale-110 animate-bounce-slow"
                aria-label="Chat on WhatsApp"
            >
                <MessageCircle size={32} />
            </a>

            {/* Header */}
            <div className="bg-gray-900 py-16 text-center text-white">
                <h1 className="text-4xl font-bold mb-4">Contact Us</h1>
                <p className="text-gray-300 max-w-xl mx-auto px-4">
                    Ready to build your dream project? Get in touch with us today.
                </p>
            </div>

            <div className="container mx-auto px-4 py-12">
                <div className="max-w-4xl mx-auto">
                    {/* Contact Information */}
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
                        <div className="bg-white p-8 rounded-xl shadow-md">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6">Contact Details</h2>

                            <div className="space-y-6">
                                <div className="flex items-start">
                                    <div className="bg-orange-100 p-3 rounded-lg mr-4 text-primary">
                                        <Phone size={24} />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Phone</h3>
                                        <p className="text-gray-600 mb-1">Mon-Sun from 9am to 6pm</p>
                                        <div className="flex flex-col space-y-1">
                                            <a href="tel:+919098027286" className="text-primary font-bold text-lg hover:underline">
                                                +91 90980 27286
                                            </a>
                                            <a href="tel:+919109107555" className="text-primary font-bold text-lg hover:underline">
                                                +91 91091 07555
                                            </a>
                                            <a href="tel:+918269484652" className="text-primary font-bold text-lg hover:underline">
                                                +91 82694 84652
                                            </a>
                                        </div>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <div className="bg-orange-100 p-3 rounded-lg mr-4 text-primary">
                                        <Mail size={24} />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Email</h3>
                                        <p className="text-gray-600 mb-1">For general inquiries</p>
                                        <a href="mailto:info@joshiconstruction.com" className="text-primary font-bold text-lg hover:underline">
                                            info@joshiconstruction.com
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="bg-white p-8 rounded-xl shadow-md">
                            <h2 className="text-2xl font-bold text-gray-800 mb-6">Visit Us</h2>
                            <div className="space-y-6">
                                <div className="flex items-start">
                                    <div className="bg-orange-100 p-3 rounded-lg mr-4 text-primary">
                                        <MapPin size={24} />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Office Address</h3>
                                        <p className="text-gray-600">
                                            144, Revenue Colony,<br />
                                            Indore, Madhya Pradesh
                                        </p>
                                    </div>
                                </div>

                                <div className="flex items-start">
                                    <div className="bg-orange-100 p-3 rounded-lg mr-4 text-primary">
                                        <Clock size={24} />
                                    </div>
                                    <div>
                                        <h3 className="font-semibold text-gray-800">Working Hours</h3>
                                        <p className="text-gray-600">
                                            Monday - Sunday<br />
                                            9:00 AM - 6:00 PM
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Map */}
                    <div className="bg-white p-2 rounded-xl shadow-md h-96 overflow-hidden">
                        <iframe
                            src="https://maps.google.com/maps?q=22.698299,75.8402086&t=&z=15&ie=UTF8&iwloc=&output=embed"
                            width="100%"
                            height="100%"
                            style={{ border: 0 }}
                            allowFullScreen=""
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            title="Google Maps Location"
                        ></iframe>
                    </div>
                </div>
            </div>

            <style jsx>{`
        @keyframes bounce-slow {
          0%, 100% { transform: translateY(0); }
          50% { transform: translateY(-10px); }
        }
        .animate-bounce-slow {
          animation: bounce-slow 2s infinite;
        }
      `}</style>
        </div>
    );
};

export default Contact;
